import React, { } from "react";
import { Button } from "react-bootstrap";
import { useGlobal } from "../../contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import { Utils } from "../../common/Utils";

const CartButton: React.FC = () => {
  const { cart } = useGlobal();
  const navigate = useNavigate();
  
  return (
    <Button variant="primary" className="position-relative" onClick={() => navigate(Utils.GetUrl("/cart"))}>
      Cart
      {cart && cart.cartItems && cart.cartItems.length > 0 && (
        <span className="position-absolute top-0 start-100 translate-middle badge bg-danger">
          {cart.cartItems.reduce((total, item) => total + item.quantity, 0)}
        </span>
      )}
    </Button>
  );
};

export default CartButton;